export default "__VITE_PUBLIC_ASSET__16b87225__"